export default __webpack_public_path__ + "static/media/right.2bc26bcd.svg";